import {ArchivePageLayout} from '@/components/decorators/archivePageLayout';
import {
  DynamicArchivePage,
  WordpressFooter,
  WordpressNavigation,
} from '@/features/archiveAsAProduct';
import {WordpressPageDto} from '@/features/archiveAsAProduct/types/dto/page';
import {SidebarContent} from '@/features/archiveAsAProduct/utils/transform/sidebar';

type ArchivePageProps = Readonly<{
  navigation: WordpressNavigation;
  page: WordpressPageDto;
  sidebar: SidebarContent;
  footer: WordpressFooter;
}>;

/**
 * Renders a page from the Wordpress CMS based on the archive and slug within the URL.
 * @param navigation - The navigation for the header of the page
 * @param page - The Wordpress page data, containing SEO and field information
 * @param footer - The information for dynamic content of the footer
 */
export default function ArchivePage(props: ArchivePageProps) {
  return (
    <ArchivePageLayout navigation={props.navigation} footer={props.footer}>
      <DynamicArchivePage page={props.page} sidebar={props.sidebar} />
    </ArchivePageLayout>
  );
}
export {getServerSideProps} from '@/features/archiveAsAProduct';
